<template lang="pug">

  transition(
    @enter="enter"
    @leave="leave"
    :css="false"
  )

    aside#menu(v-if="show")

      .overlay( @click="onCloseMenu" )

      .menu-content

        .inner

          h1.title
            span.line-one {{ lang_en['menu-title-line-one'] }}
            span.line-two {{ lang_en['menu-title-line-two'] }}

          .rating(
            @mouseleave="onMouseLeave"
            @focusout ="onMouseLeave"
          ) 
            
            star-btn(
              :tg_star_index="tg_star_index" 
              :star_index="5" 
              @navigate="onNavigate" 
              @mouseenter="onMouseEnter"
            )
            
            star-btn(
              :tg_star_index="tg_star_index" 
              :star_index="4" 
              @navigate="onNavigate" 
              @mouseenter="onMouseEnter"
            ) 
            
            star-btn(
              :tg_star_index="tg_star_index" 
              :star_index="3" 
              @navigate="onNavigate" 
              @mouseenter="onMouseEnter"
            )
            
            star-btn(
              :tg_star_index="tg_star_index" 
              :star_index="2" 
              @navigate="onNavigate" 
              @mouseenter="onMouseEnter"
            )
            
            star-btn(
              :tg_star_index="tg_star_index" 
              :star_index="1" 
              @navigate="onNavigate" 
              @mouseenter="onMouseEnter"
            )
      
        .buttons-wrap
          solid-btn( ref="solidButton" :copy="lang_en['site-check-rating-btn']" :theme="'dark'" ).check-your-rating 

        footer
          share-component( ref="share" :theme="'dark'" )
          ul.sub-links
            li
              reduced-motion-btn.footer-link
            li
              a(:href="lang_en['menu-footer-legal-url']" target="_blank").footer-link {{ lang_en['menu-footer-legal-btn'] }}
              external-link-svg.external-link
            li
              a(:href="lang_en['menu-footer-more-url']" target="_blank").footer-link {{ lang_en['menu-footer-more-btn'] }}
              external-link-svg.external-link



</template>

<script>

import { mapState, mapMutations } from 'vuex'
import gsap from 'gsap'
import Env from 'src/config/env'
import { MODAL_STATES, HOME } from 'src/config/app'
import StarBtn from '@/components/menu/star-btn'
import SolidBtn from '@/components/common/SolidBtn'
import OutlineBtn from '@/components/common/OutlineBtn'
import ReducedMotionBtn from '@/components/common/ReducedMotionBtn'
import ShareComponent from '@/components/share'
import ExternalLinkSvg from 'src/assets/svgs/external-link.svg'


export default {

  components: {
    StarBtn,
    OutlineBtn,
    SolidBtn,
    ReducedMotionBtn,
    ShareComponent,
    ExternalLinkSvg
  },

  data() {
    return {
      tg_star_index: 0,
      touchDevice: (Env.mobile || Env.tablet)
    }
  },

  computed: {

    ...mapState('app', [
      'home',
      'loading',
      'modal_state',
      'motion_clamp',
      'reduced_motion'
    ]),

    show(){
      return (this.modal_state === MODAL_STATES.MENU)
    },

    isCtaSection(){
      return (this.home.current_section.title === 'cta')
    }
  },

  mounted(){ },

  methods: {

    ...mapMutations('app', [
      'setHomeSectionByIndex',
      'setModalState'
    ]),

    onNavigate( index ){
      this.setHomeSectionByIndex( index )
      let delay = this.touchDevice ? 0.15 : 0
      gsap.delayedCall(delay, this.onNavigateDelay)
    },

    onNavigateDelay(){
      this.setModalState( MODAL_STATES.NONE )
    },

    onCloseMenu(){
      this.setModalState( MODAL_STATES.NONE )
    },
 
    onMouseEnter( index, updateSection = true ){ 
 
      if( this.touchDevice ){
        return
      }

      this.tg_star_index = index

      if(!this.isCtaSection && updateSection){
        this.setHomeSectionByIndex( index ) 
      }
    },

    onMouseLeave(){ 
 
      if(this.touchDevice ){
        return
      }

      this.tg_star_index = this.prevIndex

      if(!this.isCtaSection){
        this.setHomeSectionByIndex( this.prevIndex ) 
      } 
    },

    enter(el, done){
      
      this.prevIndex = this.home.section_index 
      this.tg_star_index = this.prevIndex
      
      if(this.$refs.outlineButton){
        this.$refs.outlineButton.enter()
      }
      
      gsap.to(el, { 
        duration: 1 * this.motion_clamp,
        opacity: 1, 
        ease : 'power3.inOut'
      })

      this.$refs.share.enter()

      done()
    },

    leave(el, done){
      gsap.to(el, { 
        duration: 0.5 * this.motion_clamp,
        opacity: 0, 
        ease : 'power3.out', 
        onComplete: done
      }) 
    }
  },

  watch: {
    'home.section_index'(val, prev){}
  }

}

</script>

<style lang="sass">
@import "src/styles/common.sass"

#menu
  +full()
  position: fixed
  font-size: 4rem
  z-index: 2
  color: #373C85
  font-family: "CondensedBold"
  opacity: 0

  .overlay
    +full()
    cursor: pointer

  .menu-content
    position: relative
    height: 100%
    width: 57rem
    +flex-center()
    flex-direction: column


    @media all and (max-width: $bp-mobile)
      width: 100%

    > .inner
      margin-top: -5rem

      h1.title
        text-align: center

        .line-one
          margin-bottom: 0.75rem
          font-size: 1.1rem
          display: block
          opacity: 0.8
          letter-spacing: 0.1rem
          text-transform: uppercase

        .line-two
          display: block
          opacity: 1
          font-size: 4.5rem
          margin-bottom: 0.5rem


      .rating
        display: flex
        justify-content: center

    .buttons-wrap
      padding: 0 14rem
      text-align: center
      position: absolute
      bottom: 26vh

      .outline-btn
        margin-top: 3rem

    footer
      position: absolute
      left: 5rem
      bottom: 5rem
      display: flex
      left: 0
      justify-content: space-between
      width: 100%
      padding: 0 4.5rem

      @media all and (max-width: $bp-mobile)
        flex-direction: column
        width: 100%
        justify-content: center
        padding: 0
        bottom: 3rem

      ul.sub-links
        position: relative
        display: flex
        justify-content: center
        align-content: space-evenly

        @media all and (max-width: $bp-mobile)
          margin-top: 3rem

        li
          margin: 0 0 0 1.8rem
          position: relative
          display: flex
          align-items: flex-end
 

      .external-link
        width: 14px
        height: 75% 
        margin: 0 0 0 2px
        opacity: 0.5
        top: 1px


      a.footer-link,
      button.footer-link
        color: #373C85
        opacity: 0.8
        font-size: 1rem
        user-select: none
        text-transform: uppercase
        letter-spacing: 0.1em
        display: block
        border-bottom: 1px solid rgba(55, 60, 133, 0.3)
        font-family: CondensedBold

        transition: opacity 0.3s ease-out
        outline: none


          

        &:hover,
        &:focus
          transition: opacity 0s ease-out
          opacity: 1 
          border-bottom: 1px solid rgba(55, 60, 133, 1)

</style>
